import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_AVR_KEYIN_DEMAND,
  GET_CUSTOMER_TYPE,
  GET_DT_DEMAND,
  GET_DT_DEMAND_COLUMN,
  SAVE_DT_DEMAND,
  SAVE_DT_DEMAND_COLUMN
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}

function Demand(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [columnDataList, setColumnDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [customerTypeOption, setCustomerTypeOption] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "year",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: colorOption[0].label,
        width: "2%",
      },
    },
  ]);
  const SumTotal = () => {
    let fieldNotSum = [
      "ROW",
      "PID",
      "year",
      "DEMAND_DATE",
      "DEMANDCOLUMN_PID",
      "DEMANDCOLUMN_ORDER",
      "DEMANDCOLUMN_NAME",
      "DEMAND_YEAR",
      "DEMAND_DATA",
      "PRIORITY_FLAG",
      "STATUS_FLAG",
      "GMDR_NAME",
      "GMDR_DATA",
      "SCADA_NAMEs",
      "SCADA_DATA",
      "FLOW_DATA",
      "Total",
    ];
    let data = modelDeviceList.map(row => {
      let sumTotal = 0;

      for (const property in row) {
        if (typeof row[property] != "object") {
          // console.log(fieldNotSum.indexOf(property),property)
          if (fieldNotSum.indexOf(property) == -1) {
            // console.log(property);
            sumTotal += parseFloat(row[property]);
          }
        }
      }
      return { ...row, Total: sumTotal };
    });
    setModelDeviceList(data);
  };
  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = () => {
    let prevHeader = document.getElementById("demand-th");
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("demand-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="demand-th" colspan="' +
      (columnDataList.length + 3) +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Average Year Demand</th>';
    thead.prepend(tr);
  };
  const getColumn = () => post(GET_DT_DEMAND_COLUMN, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        DEMANDCOLUMN_ORDER: columnManageList.length + 1,
        DEMANDCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        DEMANDCOLUMN_ALIAS: "",
        QTYPOINT_NAME: "",
        GMDRTAG_NAME: "",
        DEMANDCOLUMN_DESC: "",
        DEMANDCOLUMN_TYPE: "",
        DEMANDCOLUMN_SHOW: true,
        CUSTTYPE1_PID: "",
        CUSTTYPE1_NAME: "",
        CUSTTYPE2_PID: "",
        CUSTTYPE2_NAME: "",
        CUSTTYPE3_PID: "",
        CUSTTYPE3_NAME: "",
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        custtype: [],
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 },
      },
    ]);
  };
  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.DEMANDCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row => row.DEMANDCOLUMN_NAME == "" || row.DEMANDCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        // console.log(data)
        data = data.map(row => ({
          ...row,
          DEMANDCOLUMN_DESC: row.custtype.map(cus => cus.label).toString(),
        }));
        // console.log(data)
        let res = await post(SAVE_DT_DEMAND_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        } else {
          dispatch(messageAction.showMessage(error.message));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const generateRow = () => {
    function getDaysInMonth(year) {
      let currentYear = new Date().getFullYear();
      let yearList = [];

      for (let index = year; index <= currentYear; index++) {
        yearList.push({
          year: index,
          DEMAND_DATE: moment(new Date(index, 0, 1)).format("YYYY-MM-DD"),
          DEMAND_YEAR: moment(new Date(index, 0, 1)).format("YYYY-MM-DD"),
        });
      }
      //   console.log(yearList)
      return yearList;
    }

    let dayList;
    let startYear = 2019;
    let tmp;
    for (var i = dataList.length - 1; i >= 0; i--) {
      tmp = moment(dataList[i].DEMAND_YEAR).format("YYYY");
      if (tmp < startYear) startYear = tmp;
    }

    dayList = getDaysInMonth(startYear);
    dayList = addFieldToModelDeviceList(dayList);
    //   console.log(dayList)
    setModelDeviceList(dayList);
  };

  const formatNumber = (cellContent, row) => {
    // console.log(cellContent);
    return (
      <div>
        {numberFormat(cellContent, 2)}
      </div>
    );
  };


  const ButtonAction = (cellContent, row) => {
    // console.log(cellContent);
    // console.log(row);
    // console.log(moment().year());
    return (
      <div>
        {/* {row.year != moment().year() && ( */}
        {permission.eOTH && (
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            // onClick={() => { refreshData(row) }}
            onClick={() => {
              dispatch(
                confirmAction.showConfirm(
                  "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                  () => {
                    refreshData(row)
                  }
                )
              );
            }}
          >
            Refresh
          </button>
        )}
      </div>
    );
  };

  const renderColumn = () => {
    // console.log(columnDataList)
    setColumnRenderList([
      {
        dataField: "year",
        text: "Year",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: colorOption[0].label,
          width: "2%",
          fontSize: "12px",
        },
      },
      ...columnDataList
        .sort((a, b) =>
          a.DEMANDCOLUMN_ORDER > b.DEMANDCOLUMN_ORDER
            ? 1
            : b.DEMANDCOLUMN_ORDER > a.DEMANDCOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.DEMANDCOLUMN_SHOW == true || obj.DEMANDCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.DEMANDCOLUMN_NAME.replaceAll(".", "_"),
          text: obj.DEMANDCOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          formatter: formatNumber,
          headerStyle: {
            backgroundColor: colorOption[obj.DEMANDCOLUMN_TYPE].label,
            width: "5%",
            fontSize: "12px",
          },
          style: { 
            cursor: "pointer" 
          },
          editorStyle: () => {
            return { height: "25px" }
          },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = "";
            if (obj.STATUS_FLAG != 0) className += "from-source";
            if (obj.STATUS_FLAG == 1) className += " pmis";
            if (obj.STATUS_FLAG == 3) className += " gqms";
            return className;
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
      {
        dataField: "Total",
        text: "Total",
        headerAlign: "center",
        formatter: formatNumber,
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "5%",
          fontSize: "12px",
        },
      },
      {
        dataField: "Action",
        text: "Action",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          width: "5%",
          fontSize: "12px",
        },
        formatter: ButtonAction,
      },
    ]);
  };
  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtKeyinDemandColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          custtype: obj.DEMANDCOLUMN_DESC
            ? customerTypeOption.filter(
              opt => obj.DEMANDCOLUMN_DESC.split(",").indexOf(opt.label) >= 0
            )
            : [],
          color: colorOption[obj.DEMANDCOLUMN_TYPE],
          show:
            obj.DEMANDCOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
          source:
            obj.STATUS_FLAG == 0
              ? { label: "Manual", value: 0 }
              : obj.STATUS_FLAG == 1
                ? { label: "Scada", value: 1 }
                : { label: "Flow Selection", value: 2 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];

      modelDeviceList.map(obj => {
        columnDataList.map(objColumn => {
          data.push({
            ...obj[`${objColumn.DEMANDCOLUMN_NAME.replaceAll(".", "_")}__data`],
            DEMAND_DATA: obj[objColumn.DEMANDCOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      //   console.log(data);
      let res = await post(SAVE_DT_DEMAND, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const refreshData = async (row) => {
    // console.log(row);
    dispatch(loadingAction.showLoading());
    try {
      let refresh = await post(GET_AVR_KEYIN_DEMAND, { Year: row.year });
      if (refresh.resultCode == 200) {
        dispatch(messageAction.showMessage("Refresh success."));
        fetchData();
      } else {
        dispatch(messageAction.showMessage(refresh.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      let column = await getColumn();
      setColumnDataList(
        column.data.dtKeyinDemandColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let res = await post(GET_DT_DEMAND, {});
      setDataList(res.data.DtKeyinDemandList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const getOption = async () => {
    try {
      let res = await post(GET_CUSTOMER_TYPE, { IS_FS_GSP_FLAG: true });
      setCustomerTypeOption(
        res.data.customerTypeList
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
  };
  useEffect(() => {
    generateRow();
  }, [dataList]);
  useEffect(() => {
    getOption();
    fetchData();
  }, []);
  useEffect(() => {
    renderColumn();
    addHeaderTable();
    if (columnDataList.length > 1) {
      generateRow();
    }
  }, [columnDataList]);
  const addFieldToModelDeviceList = rowList => {
    function sumDataColumn(list) {
      // console.log(list)
      let fieldNotSum = [
        "ROW",
        "PID",
        "year",
        "DEMAND_DATE",
        "DEMANDCOLUMN_PID",
        "DEMANDCOLUMN_ORDER",
        "DEMANDCOLUMN_NAME",
        "DEMAND_YEAR",
        "DEMAND_DATA",
        "PRIORITY_FLAG",
        "STATUS_FLAG",
        "GMDR_NAME",
        "GMDR_DATA",
        "SCADA_NAMEs",
        "SCADA_DATA",
        "FLOW_DATA",
        "Total",
      ];
      let data = list.map(row => {
        let sumTotal = 0;

        for (const property in row) {
          if (typeof row[property] != "object") {
            // console.log(fieldNotSum.indexOf(property),property)
            if (fieldNotSum.indexOf(property) == -1) {
              // console.log(row[property])
              sumTotal += parseFloat(row[property]);
            }
          }
        }
        return { ...row, Total: sumTotal };
      });
      return data;
    }
    let dataModel = {
      PID: "",
      DEMAND_DATE: "",
      DEMANDCOLUMN_PID: "",
      DEMANDCOLUMN_ORDER: 0,
      DEMANDCOLUMN_NAME: "",
      DEMAND_YEAR: "",
      DEMAND_DATA: 0,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
      GMDR_NAME: "",
      GMDR_DATA: 0,
      SCADA_NAME: "",
      SCADA_DATA: 0,
      FLOW_DATA: 0,
    };
    if (rowList.length > 0) {
      // console.log(dataList)
      let data = dataList;
      let modelList = [];
      columnDataList.map(objColumn => {
        modelList = [
          ...rowList.map(obj => {
            let value = data.find(
              value =>
                value.DEMANDCOLUMN_PID == objColumn.PID &&
                moment(value.DEMAND_YEAR).format("YYYY") ==
                moment(obj.DEMAND_YEAR).format("YYYY")
            );
            let total = 0;
            obj[objColumn.DEMANDCOLUMN_NAME.replaceAll(".", "_")] = value
              ? value.DEMAND_DATA
              : 0;
            obj[`${objColumn.DEMANDCOLUMN_NAME.replaceAll(".", "_")}__data`] = {
              ...dataModel,
              ...value,
              DEMAND_DATE: obj.DEMAND_DATE,
              DEMAND_YEAR: obj.DEMAND_YEAR,
              DEMANDCOLUMN_PID: objColumn.PID,
              DEMANDCOLUMN_ORDER: objColumn.DEMANDCOLUMN_ORDER,
              DEMANDCOLUMN_NAME: objColumn.DEMANDCOLUMN_NAME,
            };
            return { ...obj, Total: total };
          }),
        ];
      });
      modelList = sumDataColumn(modelList);
      return modelList;
    }
  };

  const SelectCustomerType1 = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={true}
          isMulti
          onChange={selected => {
            setColumnManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    CUSTTYPE1_PID: selected ? selected.value : null,
                    CUSTTYPE1_NAME: selected ? selected.label : null,
                    custtype: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={customerTypeOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const columnOption = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#2E3446" : undefined,
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#2A3042",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#BFC8E2",
      ":hover": {
        backgroundColor: "#2A3042",
        color: "white",
      },
    }),
  };
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  DEMANDCOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  DEMANDCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectSource = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Manual", value: 0 },
          // { label: "Scada", value: 1 },
          { label: "Flow Selection", value: 2 },
          // { label: "GQMS", value: 3 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  source: selected,
                  STATUS_FLAG: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManage = [
    {
      dataField: "DEMANDCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "DEMANDCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "DEMANDCOLUMN_ALIAS",
      text: "Report Name",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "100px",
        cursor:"pointer",
      },
    },
    {
      dataField: "source",
      text: "Source",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "125px",
        cursor:"pointer",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectSource,
    },
    {
      dataField: "custtype",
      text: "Customer Type",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "200px",
      },
      formatter: SelectCustomerType1,
    },

    // {
    //   dataField: "SCADATAG_NAME",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "DEMANDCOLUMN_DESC",
    //   text: "Description",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    // },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColor,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];

  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end">

          {permission.mMIM && (
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => handleShowManageColumn()}
            >
              <i className="bx bx-columns"></i>&nbsp; Manage Column Average
              Year Demand
            </button>
          )}
          {permission.eOTH && (
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={handleSaveData}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
          )}
        </div>
        <div className="mt-2">
          <BootstrapTable
            id="demand-tab-table"
            keyField="year"
            data={modelDeviceList}
            rowStyle={rowStyleFontWhite}
            columns={columnRenderList}
            headerClasses="header-style"
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              onStartEdit: (oldValue, newValue, row, column) => {
                $("#demand-tab-table .form-control.editor.edit-text").bind(
                  "enterKey",
                  function (e) {
                    let cell = $(this).parent().next();
                    setTimeout(() => {
                      cell.click();
                    }, 50);
                  }
                );
                $("#demand-tab-table .form-control.editor.edit-text").keypress(
                  function (e) {
                    if (e.keyCode == 13) {
                      $(this).trigger("enterKey");
                    }
                  }
                );
              },
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
                SumTotal();
              },
            })}
          />
        </div>
      </Col>

      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Average Year Demand</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-demand-table"
            keyField="ROW"
            wrapperClasses="table-on-scroll"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "DEMANDCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default Demand;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

Demand.propTypes = {
  // yearSelected: PropTypes.any,
};
